//export const baseApiUrl = "http://uat-agx-par-api.pyaoyue.com" + version;//
import Vue from "vue";
import { Loading } from 'element-ui';

export const BASEURL= "http://test-gateway-agx-api.pyaoyue.com";
//export const baseApiUrl = "http://localhost:1002";
//export const baseApiUrl = "https://prod-agx-api.pyaoyue.com/par" + version;
//export const baseApiUrl = "http://localhost:8384" + version;//

export const AGENT ="/agx-agent";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
export const AGXPARTNER ="/agx-partner";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
export const AGXCOLLEGE ="/agx-college";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数
export const AGXRELATION="/agx-relation-cust";  //-----注册到vue的全局，方便各个组件和页面js调用公共函数



let loadingCount = 0;
let loading;

const startLoading = (val) => {
  loading = Loading.service({
    lock: true,
    text: '正在导出，请耐心等待……',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};

const endLoading = () => {
  loading.close();
};

export const showLoading = (val) => {
  if (loadingCount === 0) {
    startLoading(val);
  }
  loadingCount += 1;
};

export const hideLoading = () => {
  if (loadingCount <= 0) {
    return;
  }
  loadingCount -= 1;
  if (loadingCount === 0) {
    endLoading();
  }
};


// WEBPACK FOOTER //
// ./src/utils/common.js